import { Component, Vue } from "vue-property-decorator";
import { Company, Brand, Product } from "@/models";

@Component({})
export default class ClickableEntryListenerMixin extends Vue {
  onEntryClick(item: Company | Brand | Product, filter: any) {
    this.$router.push({
      name: "InvestorSummary",
      params: {
        type: item.type,
        id: item.id,
      },
      query: {
        from: filter.date.from,
        to: filter.date.to,
        radio: filter.media.radio ? "1" : "0",
        tv: filter.media.tv ? "1" : "0",
      },
    });
  }
}
